/** The recognized attachment types along with their extensions. */
const extensions = {
    image: ['jpg', 'jpeg', 'bmp', 'gif', 'tiff', 'png', 'webp'],
    video: ['mp4', 'm4v', 'mpeg', 'mpg', 'mov', 'avi', 'wmv', 'webm', 'flv'],
    audio: [
        'aac',
        'wav',
        'mp3',
        'aiff',
        'acc',
        'ogg',
        'oga',
        'wma',
        'flac',
        'alac',
    ],
};
/**
 * Gets the attachment type for the attachment.
 *
 * @param attachment The attachment.
 */
export function getMessageFileType(messageFile) {
    const filename = messageFile.pretty_name;
    const extension = filename.substring(filename.lastIndexOf('.') + 1);
    return Object.keys(extensions).find((messageFileType) => extensions[messageFileType].includes(extension));
}
